import { motion } from "framer-motion";
import { Zap, Filter, CalendarCheck, RefreshCw } from "lucide-react";

const tiles = [
  {
    icon: Zap,
    title: "Responds in 60 seconds",
    description: "Your AI replies to every lead within 60 seconds. Day or night. Whether you're on a call, at dinner, or asleep.",
  },
  {
    icon: Filter,
    title: "Qualifies on autopilot",
    description: "It asks the right questions, filters out time wasters, and only sends you leads that are actually worth your time.",
  },
  {
    icon: CalendarCheck,
    title: "Books calls automatically",
    description: "No booking links. No back and forth. The AI guides the conversation and locks in the appointment directly.",
  },
  {
    icon: RefreshCw,
    title: "Follows up for 90 days",
    description: "Most leads don't convert on the first message. Your AI follows up consistently for 90 days without you touching it.",
  },
];

export default function WhatWeDo() {
  return (
    <section data-testid="what-we-do-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-14 md:mb-16"
        >
          <h2
            data-testid="what-we-do-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight max-w-3xl"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            AppoinText builds you a custom AI setter that{" "}
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">never sleeps.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {tiles.map((tile, i) => {
            const Icon = tile.icon;
            return (
              <motion.div
                key={tile.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.08 }}
                data-testid={`tile-${i}`}
                className="bg-zinc-900/40 border border-white/[0.06] rounded-2xl p-7 md:p-8 hover:border-blue-500/20 transition-all duration-300 group"
              >
                <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center mb-5">
                  <Icon size={20} className="text-blue-400" />
                </div>
                <h3 className="text-white text-lg font-bold mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {tile.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed">
                  {tile.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
